import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback,WarningCallback } from "alertService"
import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate" 
import { thaiBath } from "helpers/ConvertFormat" 
import {arrayObject} from "ConvertKey"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite"; 
import FormLabel from "@material-ui/core/FormLabel"
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusWaitingUpdate: true,
      dataListRaw: [],
      dataList: [],

      currentSettingId: "",
      dataListSetting: []
    }
  }
  componentDidMount() { 
    Alert.Loading(true)
    this.loadSettingDataList(()=>{ 
      Alert.LoadingClose()
    })
  }
  loadSettingDataList = (callback)=>{ 
    APIPost( UrlServer.URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST,{},({datas})=>{ 
      var newConvertDatas = arrayObject(datas,[
        {
          oldKey:"_id",
          newKey:"value"
        },
        {
          oldKey:"description",
          newKey:"name"
        },
        {
          oldKey:"data_year",
          newKey:"data_year"
        },
        {
          oldKey:"created_date_iso",
          newKey:"created_date_iso"
        },
        {
          oldKey:"total_leads",
          newKey:"total_leads"
        }
      ]
      )
      newConvertDatas.map((data,index)=>{ 
        newConvertDatas[index]["name"] = data["name"] + " : " + ISOToDateYMDAndFullTime(data["created_date_iso"])+" ("+data["total_leads"]+")"
      })
      this.setState({  
          dataListSetting:newConvertDatas
        },()=>{ 
          callback()
        }); 
    })  
  }
  handleDonwloadImportID = (e)=>{
    if(this.state.currentSettingId == "" || !this.state.currentSettingId){
      WarningCallback("เลือกชื่อข้อมูล Lead ก่อน",()=>{ 
      })
      return 
    }
    Alert.Loading(true)
    var data_fro_send = {
      lead_setting_id:this.state.currentSettingId,
      data_year:this.state.data_year,
    }
    APIPost( UrlServer.URL_POST_IMPORT_EXCEL_DATA_LEAD_FROM_SETTING,data_fro_send,({datas})=>{ 
      var dataList = this.renderListData(datas)
      this.setState({ 
        dataListRaw: datas,
        dataList: dataList
      },()=>{ 
        if(datas.length != 0){
          Alert.LoadingClose()
        }else{
          WarningCallback("ชื่อข้อมูลที่เลือกไม่มีรายการ",()=>{ 
          })
        }
      })
    })  
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        first_name: CData.first_name,
        last_name: CData.last_name,
        tel: CData.tel,
        send_sms_date: ISOToDateYMD(CData.send_sms_date), 
        sms_expired_date: ISOToDateYMD(CData.sms_expired_date), 
        actions:  "" 
      }
    })
  }
  handleChangeState = name => event => { 
    var _data_year = ""
    if(this.state.dataListSetting){
      this.state.dataListSetting.map((row)=>{
        if(event.target.value == row.value){
          _data_year = row.data_year
        }
      })
    }
    this.setState({
      [name]: event.target.value,
      data_year:_data_year
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ Lead</h4>
              </CardHeader>
              <CardBody>
                <GridContainer className="GridContainer-lm001">
                  <GridItem xs={12} sm={12} md={3} lg={3}>
                    <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                      ชื่อข้อมูล Lead ที่นำเข้า
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6} lg={6}>
                    {
                      (this.state.dataListSetting.length > 0) ?
                        <Select
                          value={this.state.currentSettingId}
                          listData={this.state.dataListSetting}
                          onChange={this.handleChangeState("currentSettingId")}
                        />
                      : ""
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3} lg={3}>
                    <Button
                      round
                      color="info"
                      className="Button-001"
                      onClick={this.handleDonwloadImportID}
                      fullWidth={true}
                    >
                      <CloudDownloadIcon className={classes.icons} />
                       แสดงข้อมูล
                    </Button>
                  </GridItem>
                </GridContainer>
                <span>จำนวน {thaiBath(this.state.dataList.length,false)} รายการ</span> 
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "id",
                      width:70
                    },
                    {
                      Header: "ชื่อ",
                      accessor: "first_name"
                    },
                    {
                      Header: "สกุล",
                      accessor: "last_name"
                    }, 
                    {
                      Header: "เบอร์ติดต่อ",
                      accessor: "tel"
                    }, 
                    {
                      Header: "วันที่ตั้งส่ง SMS",
                      accessor: "send_sms_date"
                    }, 
                    {
                      Header: "วันที่ sms หมดอายุ",
                      accessor: "sms_expired_date"
                    }, 
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
} 
export default withStyles(styles)(UserFromImportListManagement)
